import * as echarts from 'echarts'
import store from '../../../store'
export default {
    // 国内专利分析
    // 1.国内专利趋势
    domesticzl1: function () {
        let myChart = echarts.init(document.querySelector(".domesticzl1"));
       
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
            },
            legend: {
                right: 50,
                icon: "rect",
                data: ['申请量', '授权量']
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
                // top:'-50%'
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: true,
                    data: store.state.trendTime,
                    axisLabel: {
                        fontSize: 12,
                        color: "#000",
                        show: true,
                        interval: 0
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#ddd",
                            width: 2
                        }
                    },
                    axisTick: {
                        show: false
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',

                    axisLabel: {
                        color: "#ddd",
                        fontSize: 12
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#ddd",
                            width: 2
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        lineStyle: {
                            color: "#ddd"
                        }
                    }
                }
            ],
            series: [
                {
                    name: '申请量',
                    type: 'line',
                    lineStyle: {
                      
                            color: '#E02020',
                            width: 2
                      

                    },
                    color: '#E02020',
                    areaStyle: {
                        color: ' rgba(224, 32, 32,.3)',
                    },
                    smooth: true,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        color: "#000"
                    },
                    
                    data: store.state.trendApListYapply

                },
                {
                    name: '授权量',
                    type: 'line',
                    lineStyle: {
                        // normal: {
                            color: '#6236FF',
                            width: 2
                        // }
                    },
                    color: '#6236FF',
                    areaStyle: {
                        color: 'rgba(98, 54, 255,.3)'
                    },
                    smooth: true,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        color: "#000"
                    },
                    
                    data: store.state.trendApListYagree
                },
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 2.专利类型构成
    domesticzl2: function () {
        let myChart = echarts.init(document.querySelector(".domesticzl2"));
        let options = {
            tooltip: {
                trigger: 'item'
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            legend: {
                orient: 'vertical',
                left: 'left',
                icon: 'circle',
                top: 30,
                formatter: function (name) {
                    let values = []
                    let index = 0
                    store.state.apTyCount.forEach((ele, i) => {
                        values.push(ele.value)
                        if (ele.name == name) {
                            index = i
                        }
                    })
                    return name + "：" + values[index]
                }
            },
            series: [
                {
                    type: 'pie',
                    radius: '50%',
                    data: store.state.apTyCount,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        formatter: "{b}:{c}"
                    },
                    color: ['#73A0FA', '#73DEB3', '#FFAB67'],
                    radius: ['0', '80%'],
                    center: ['55%', '45%']
                }
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    domesticzl2sq: function () {
        let myChart = echarts.init(document.querySelector(".domesticzl2sq"));
        let options = {
            tooltip: {
                trigger: 'item'
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            legend: {
                orient: 'vertical',
                left: 'left',
                icon: 'circle',
                top: 30,
                formatter: function (name) {
                    let values = []
                    let index = 0
                    store.state.apTyAuthCount.forEach((ele, i) => {
                        values.push(ele.value)
                        if (ele.name == name) {
                            index = i
                        }
                    })
                    return name + "：" + values[index]

                }
            },
            series: [
                {
                    type: 'pie',
                    radius: '50%',
                    data: store.state.apTyAuthCount,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        formatter: "{b}:{c}"
                    },
                    color: ['#73A0FA', '#73DEB3', '#FFAB67'],
                    radius: ['0', '80%'],
                    center: ['55%', '45%']
                }
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 3.IPC技术分类top10
    domesticzl3: function () {
        let myChart = echarts.init(document.querySelector(".domesticzl3"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                top: '8%',
                right: '3%',
                bottom: '2%',
                containLabel: true,
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    formatter: function () {
                        return "";
                    }
                }
            },
            yAxis: {
                type: 'category',
                axisTick: {
                    show: false
                },
                data: store.state.ipcCountY,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.ipcCountX,
                    itemStyle: {
                        // normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#3370ed'
                            }, {
                                offset: 1,
                                color: '#94c2fd'

                            }
                        ])
                        },
                    // },
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    domesticzl3sq: function () {
        let myChart = echarts.init(document.querySelector(".domesticzl3sq"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                top: '8%',
                right: '3%',
                bottom: '2%',
                containLabel: true,
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    formatter: function () {
                        return "";
                    }
                }
            },
            yAxis: {
                type: 'category',
                axisTick: {
                    show: false
                },
                data: store.state.ipcAuthCountY,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.ipcAuthCountX,
                    itemStyle: {
                        // normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#3370ed'
                            }, {
                                offset: 1,
                                color: '#94c2fd'

                            }])
                        // }
                    },
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 4.专利分析榜单
    domesticzl4: function () {
        let myChart = echarts.init(document.querySelector(".domesticzl4"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 20
            },
            grid: {
                left: '2%',
                top: '8%',
                right: '3%',
                bottom: '2%',
                containLabel: true,
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                show: true,
                axisTick: {
                    show: true,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.appTop10Y,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",

                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }

                },
                inverse: true

            },
            series: [
                {
                    type: 'bar',
                    itemStyle: {
                        // normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#5ba1ff'
                            }, {
                                offset: 1,
                                color: '#2dc9fd'

                            }])
                        // }
                    },
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    data: store.state.appTop10X,
                    barMaxWidth:55

                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    domesticzl4sq: function () {
        let myChart = echarts.init(document.querySelector(".domesticzl4sq"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 20
            },
            grid: {
                left: '2%',
                top: '8%',
                right: '3%',
                bottom: '2%',
                containLabel: true,
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                show: true,
                axisTick: {
                    show: true,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.authTop10Y,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }
                },
                inverse: true

            },
            series: [
                {
                    type: 'bar',
                    itemStyle: {
                        // normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#5ba1ff'
                            }, {
                                offset: 1,
                                color: '#2dc9fd'

                            }])
                        // }
                    },
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    data: store.state.authTop10X,
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    domesticzl4yx: function () {
        let myChart = echarts.init(document.querySelector(".domesticzl4yx"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 20
            },
            grid: {
                left: '2%',
                top: '8%',
                right: '3%',
                bottom: '2%',
                containLabel: true,
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                show: true,
                axisTick: {
                    show: true,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.validTop10Y,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }
                },
                inverse: true,

            },
            series: [
                {
                    type: 'bar',
                    itemStyle: {
                        // normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#5ba1ff'
                            }, {
                                offset: 1,
                                color: '#2dc9fd'

                            }])
                        // }
                    },
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    data: store.state.validTop10X,
                    barMaxWidth:55

                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    domesticzl4wx: function () {
        let myChart = echarts.init(document.querySelector(".domesticzl4wx"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 20
            },
            grid: {
                left: '2%',
                top: '8%',
                right: '3%',
                bottom: '2%',
                containLabel: true,
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                show: true,
                axisTick: {
                    show: true,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.notValidTop10Y,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    itemStyle: {
                        // normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#5ba1ff'
                            }, {
                                offset: 1,
                                color: '#2dc9fd'

                            }])
                        // }
                    },
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    data: store.state.notValidTop10X,
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // PCT公开专利分析
    // 1.PCT专利趋势
    pctzl1: function () {
        let myChart = echarts.init(document.querySelector(".pctzl1"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                top: '15%',
                right: '8%',
                bottom: '5%',
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: true,
                data: store.state.trendTime,
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 10,
                    color: "#000",
                    interval:0
                },
            },
            yAxis: {
                type: 'value',
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000"
                },
            },
            series: [{
                name: '公开量',
                data: store.state.pctTrendCountY,
                type: 'line',
                areaStyle: {
                    color: 'rgba(91, 143, 249,.3)'
                },
                label: {
                    show: true,
                    color: "#000",
                    position: 'top'
                },
                smooth: true,
                lineStyle: {
                    normal: {
                        color: '#5B8FF9',
                        width: 2
                    }

                },
            }]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 2.IPC分类Top10
    pctzl2: function () {
        let myChart = echarts.init(document.querySelector(".pctzl2"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            legend: {
                right: 30,
                icon: 'rect'
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "15%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: false
                },

            },
            yAxis: {
                type: 'category',
                data: store.state.pctIpcTop10Y,
                triggerEvent: true,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter: function (params) {
                        var val = ""
                        if (params.length > 10) {
                            val = params.substr(0, 10) + "..."
                            return val
                        } else {
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    name: '申请量',
                    type: 'bar',
                    data: store.state.pctIpcTop10X,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#5B8FF9'
                            }, {
                                offset: 1,
                                color: '#94C2FD'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 3.PCT公开量Top10
    pctzl3: function () {
        let myChart = echarts.init(document.querySelector(".pctzl3"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: false
                },

            },
            yAxis: {
                type: 'category',
                data: store.state.pctTop10CountY,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    
                },
                inverse: true
            },
            series: [
                {

                    type: 'bar',
                    data: store.state.pctTop10CountX,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#18A069'
                            }, {
                                offset: 1,
                                color: '#81DB7C'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 专利状态分析
    // 1.专利状态分析
    statuszl: function () {
        let myChart = echarts.init(document.querySelector(".statuszl"));
        let options = {
            tooltip: {
                trigger: 'item'
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },

            legend: {
                orient: 'vertical',
                left: 'left',
                icon: 'circle',
                top: 40,
                left: 100,
                formatter: function (name) {
                    let values = []
                    let index = 0
                    store.state.ptLawCount.forEach((ele, i) => {
                        values.push(ele.value)
                        if (ele.name == name) {
                            index = i
                        }
                    })
                    return name + "：" + values[index]
                }
            },
            series: [
                {

                    type: 'pie',
                    radius: '50%',
                    data: store.state.ptLawCount,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    color: ['#5B8FF9', '#5AD8A6', '#5D7092', '#F6BD16', '#E8684A'],
                    radius: ['0', '75%'],
                    center: ['50%', '50%'],
                    label: {
                        formatter: "{b}:{c}"
                    },
                }
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 国内商标分析
    // 1.国内商标趋势
    domesticsb1: function () {
        let myChart = echarts.init(document.querySelector(".domesticsb1"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
                // showContent:true
            },
            legend: {
                right: 50,
                icon: "rect",
                data: ['申请量', '注册量']
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
                // top:'-50%'
            },
            grid: {
                left: '2%',
                right: '6%',
                top: '15%',
                bottom: '2%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: true,
                    data: store.state.trendTime,
                    axisLabel: {
                        fontSize: 14,
                        color: "#000",
                        interval:0
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#ddd",
                            width: 2
                        }
                    },
                    axisTick: {
                        show: false
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',

                    axisLabel: {
                        color: "#ddd",
                        fontSize: 12
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#ddd",
                            width: 2
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        lineStyle: {
                            color: "#ddd"
                        }
                    }
                }
            ],
            series: [
                {
                    name: '申请量',
                    type: 'line',
                    lineStyle: {
                        normal: {
                            color: '#5B8FF9',
                            width: 2
                        }

                    },
                    color: '#5B8FF9',
                    areaStyle: {
                        color: 'rgba(91, 143, 249,.3)',
                    },
                    smooth: true,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        color: "#000"
                    },
                    
                    data: store.state.tmTrendMapY1

                },
                {
                    name: '注册量',
                    type: 'line',
                    lineStyle: {
                        normal: {
                            color: '#5AD8A6',
                            width: 2
                        }
                    },
                    color: '#5AD8A6',
                    areaStyle: {
                        color: 'rgba(90, 216, 166,.3)'
                    },
                    smooth: true,
                    emphasis: {
                        focus: 'series'
                    },
                    label: {
                        show: true,
                        color: "#000"
                    },
                   
                    data: store.state.tmTrendMapY2
                },
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 2.国际分类Top10
    domesticsb2: function () {
        let myChart = echarts.init(document.querySelector(".domesticsb2"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.icTop10MapY,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.icTop10MapX,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#28BEAE'
                            }, {
                                offset: 1,
                                color: '#3EDDCC'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    domesticsb2zc: function () {
        let myChart = echarts.init(document.querySelector(".domesticsb2zc"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.icRegTop10MapY,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000"
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.icRegTop10MapX,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#28BEAE'
                            }, {
                                offset: 1,
                                color: '#3EDDCC'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 3.商标分析榜单
    domesticsb3: function () {
        let myChart = echarts.init(document.querySelector(".domesticsb3"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.topApp10MapY,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.topApp10MapX,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#0396FF'
                            }, {
                                offset: 1,
                                color: '#75C5FE'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    domesticsb3zc: function () {
        let myChart = echarts.init(document.querySelector(".domesticsb3zc"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.topReg10MapY,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.topReg10MapX,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#0396FF'
                            }, {
                                offset: 1,
                                color: '#75C5FE'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    domesticsb3yx: function () {
        let myChart = echarts.init(document.querySelector(".domesticsb3yx"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.topValid10MapY,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.topValid10MapX,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#0396FF'
                            }, {
                                offset: 1,
                                color: '#75C5FE'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 马德里商标分析
    // 1.马德里商标趋势
    mdl1: function () {
        let myChart = echarts.init(document.querySelector(".mdl1"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                top: '10%',
                right: '3%',
                bottom: '5%',
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: true,
                data: store.state.trendTime,
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000"
                },
            },
            yAxis: {
                type: 'value',
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#ddd"
                },
            },
            series: [{
                name: '注册量',
                data: store.state.mdltrendY,
                type: 'line',
                areaStyle: {
                    color: 'rgba(250, 100, 0,.3)'
                },
                color: '#FA6400',
                smooth: true,
                label: {
                    show: true,
                    color: "#000",
                    position: 'top'
                },
                lineStyle: {
                    normal: {
                        color: '#FA6400',
                        width: 2
                    }

                },
               
            }]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 2.马德里延伸国家TOP20
    mdl2: function () {
        let myChart = echarts.init(document.querySelector(".mdl2"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            grid: {
                top: '15%',
                bottom: '8%',
                left: "5%",
                right: "3%",
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            xAxis: {
                type: 'category',
                data: store.state.mdltop20X,
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2

                    }
                },
                axisLabel: {
                    color: "#000",
                    show: true
                },
                axisTick: {
                    show: false
                }
            },
            yAxis: {
                type: 'value',
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2

                    }
                }
            },
            series: [{
                name: '马德里注册量',
                data: store.state.mdltop20Y,
                type: 'bar',
                label: {
                    show: true,
                    color: "#000",
                    position: 'top'
                },
                itemStyle: {
                    normal: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: '#2DAFFD'
                        }, {
                            offset: 1,
                            color: '#1477FB'

                        }])
                    }
                },
                barMaxWidth:55
            }]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 3.马德里注册量Top10
    mdl3: function () {
        let myChart = echarts.init(document.querySelector(".mdl3"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.mdlregY,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                }
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.mdlregX,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#FF6417'
                            }, {
                                offset: 1,
                                color: '#FF970C'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 商标状态分析
    // 1.商标状态分析
    statussb: function () {
        let myChart = echarts.init(document.querySelector(".statussb"));
        let options = {
            tooltip: {
                trigger: 'item'
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },

            legend: {
                orient: 'vertical',
                left: 'left',
                icon: 'circle',
                top: 40,
                left: 100,
                formatter: function (name) {
                    let values = []
                    let index = 0
                    store.state.lawMap.forEach((ele, i) => {
                        values.push(ele.value)
                        if (ele.name == name) {
                            index = i
                        }
                    })
                    return name + "：" + values[index]
                }
            },
            series: [
                {

                    type: 'pie',
                    radius: '50%',
                    data: store.state.lawMap,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    color: ['#5B8FF9', '#5AD8A6', '#5D7092'],
                    radius: ['0', '75%'],
                    center: ['50%', '50%'],
                    label: {
                        formatter: "{b}:{c}"
                    },
                }
            ]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 商标运营分析
    // 1.商标转让趋势
    sbmani1: function () {
        let myChart = echarts.init(document.querySelector(".sbmani1"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                top: '15%',
                right: '8%',
                bottom: '5%',
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: true,
                data: store.state.trendTime,
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    interval:0
                },
            },
            yAxis: {
                type: 'value',
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000"
                },
            },
            series: [{
                name: '商标转让量',
                data: store.state.tmTransferMapY,
                type: 'line',
                areaStyle: {
                    color: 'rgba(91, 143, 249,.3)'
                },
                label: {
                    show: true,
                    color: "#000",
                    position: 'top'
                },
                smooth: true,
                lineStyle: {
                    normal: {
                        color: '#5B8FF9',
                        width: 2
                    }

                },
            }]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 2.商标转让类别Top10
    sbmani2: function () {
        let myChart = echarts.init(document.querySelector(".sbmani2"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "12%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true,
                    color: "#000"
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.tmIcTrfTopY,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse: true
            },
            series: [
                {
                    name: '商标转让量',
                    type: 'bar',
                    data: store.state.tmIcTrfTopX,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#1477FB'
                            }, {
                                offset: 1,
                                color: '#2DAFFD'
                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 3.商标许可趋势
    sbmani3: function () {
        let myChart = echarts.init(document.querySelector(".sbmani3"));
        let options = {
            
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                top: '15%',
                right: '8%',
                bottom: '5%',
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: true,
                data: store.state.trendTime,
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    interval:0
                },
            },
            yAxis: {
                type: 'value',
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000"
                },
            },
            series: [{
                name: '商标许可量',
                data: store.state.tmLicenseMapY,
                type: 'line',
                areaStyle: {
                    color: 'rgba(250, 100, 0,.3)'
                },
                color: '#FA6400',
                label: {
                    show: true,
                    color: "#000",
                    position: 'top'
                },
                smooth: true,
                lineStyle: {
                    normal: {
                        color: '#FA6400',
                        width: 2
                    }

                },
            }]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 4.商标许可类别Top10
    sbmani4: function () {
        let myChart = echarts.init(document.querySelector(".sbmani4"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "12%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true,
                    color: "#000"
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.tmIcLicTopY,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse:true
            },
            series: [
                {
                    name: '商标许可量',
                    type: 'bar',
                    data: store.state.tmIcLicTopX,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#FF9638'
                            }, {
                                offset: 1,
                                color: '#FFBC7F'
                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 5.商标质押趋势
    sbmani5: function () {
        let myChart = echarts.init(document.querySelector(".sbmani5"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                top: '15%',
                right: '8%',
                bottom: '5%',
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: true,
                data: store.state.trendTime,
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000",
                    interval:0
                },
            },
            yAxis: {
                type: 'value',
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#000"
                },
            },
            series: [{
                name: '商标质押量',
                data: store.state.tmPledgeMapY,
                type: 'line',
                areaStyle: {
                    color: 'rgba(39, 183, 99,.3)'
                },
                color: '#27B763',
                label: {
                    show: true,
                    color: "#000",
                    position: 'top'
                },
                smooth: true,
                lineStyle: {
                    normal: {
                        color: '#27B763',
                        width: 2
                    }

                },
            }]
        }
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 6.商标质押类别Top10
    sbmani6: function () {
        let myChart = echarts.init(document.querySelector(".sbmani6"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                show: true,
                icon: 'rect',
                right: 30
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 30
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "12%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true,
                    color: "#000"
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.tmIcPldTopY,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse:true
            },
            series: [
                {
                    name: '商标质押量',
                    type: 'bar',
                    data: store.state.tmIcPldTopX,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#37C973'
                            }, {
                                offset: 1,
                                color: '#68E6AB'
                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    // 7.商标运营分析榜单
    sbmani7: function () {
        let myChart = echarts.init(document.querySelector(".sbmani7"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.tmTrfTop10Y,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse:true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.tmTrfTop10X,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#1477FB'
                            }, {
                                offset: 1,
                                color: '#2DAFFD'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    sbmani7xk: function () {
        let myChart = echarts.init(document.querySelector(".sbmani7xk"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.tmLicTop10Y,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse:true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.tmLicTop10X,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#1477FB'
                            }, {
                                offset: 1,
                                color: '#2DAFFD'

                            }])
                        }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
    sbmani7zy: function () {
        let myChart = echarts.init(document.querySelector(".sbmani7zy"));
        let options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title:false
                    }
                },
                bottom: 10
            },
            grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                top: "8%",
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    show: true
                },
                axisTick: {
                    show: false
                }

            },
            yAxis: {
                type: 'category',
                data: store.state.tmPldTop10Y,
                axisLine: {
                    lineStyle: {
                        color: "#ddd",
                        width: 2
                    }
                },
                axisLabel: {
                    color: "#000",
                    formatter:function(params){
                        var val=""
                        if(params.length>10){
                            val=params.substr(0,10)+"..."
                            return val
                        }else{
                            return params
                        }
                    }
                },
                inverse:true
            },
            series: [
                {
                    type: 'bar',
                    data: store.state.tmPldTop10X,
                    label: {
                        show: true,
                        color: "#000",
                        position: 'right'
                    },
                    itemStyle: {
                        // normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: '#1477FB'
                            }, {
                                offset: 1,
                                color: '#2DAFFD'

                            }])
                        // }
                    },
                    barMaxWidth:55
                },

            ]
        };
        myChart.setOption(options);
        window.addEventListener('resize', () => {
            myChart.resize()
        })
    },
}